import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2f3bc6a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"5vw"} }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div style=\"display:flex;flex-direction:column;align-items:left;\" data-v-2f3bc6a1><a href=\"#wasm\" data-v-2f3bc6a1>🧮 Collatz Conjecture Calculator</a><a href=\"#maze\" data-v-2f3bc6a1>🔎 A* Algorithm with Recursive Backtracking</a><a href=\"#coffee\" data-v-2f3bc6a1>☕ Influence of Electric Taste</a><a href=\"#weeks\" data-v-2f3bc6a1>📅 How Many Weeks</a><a href=\"#movie-list\" data-v-2f3bc6a1>🍿 Movie Watch List</a><a href=\"#stills\" data-v-2f3bc6a1>🖌️ Blender Design</a><a href=\"#stills\" data-v-2f3bc6a1>📹 3D Animation</a></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { ref, computed } from "vue";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "ContentsVue",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})